import React from "react";
import { FormGroup, Heading, Alert, Table } from "arag-ui-lib";
import CONTENT_STRINGS from "../../../helpers/contentStrings";
import { HEADING_3, ERROR } from "../../../helpers/constants";
import { FORM_GROUP_VARIANTS } from "../../../helpers/formGroupVariants";
import { getStepMessage, onChangeStoreSettings } from '../../../helpers/premiumSettingsFunctions';


const SharedStep4 = (props) => {

    const {
        isPercentagePremium,
        currentStep,
        recoverableRatePercentage,
        changeStoreSettings,
        validationMessage,
        columns,
        data,
        topHeader,
        groups,
        verticalHeaders,
        stepMessages,
        outerVerticalHeaders,
        decimalErrors,
        checkDecimal
    } = props;

    if (currentStep !== 4)
        return null;

    const stepMessage = getStepMessage(4, stepMessages);
    return (
        <div>
            <Heading
                variant={HEADING_3}
                title={stepMessage}
                headingTestId={'edit-application-premium-setting-instructions'}
            />
            {isPercentagePremium
            ?
                <FormGroup
                    labelSize={'col-sm-3'}
                    inputSize={'col-sm-7'}
                    label={CONTENT_STRINGS.RECOVERABLE_RATE}
                    variant={FORM_GROUP_VARIANTS.CURRENCY}
                    errorMessage={decimalErrors?.recoverableRatePercentage}
                    inputProps={{
                        id: 'recoverableRatePercentage',
                        required: true,
                        onChange: (e) => {
                            const cleaned = e.target.value.replace(/[^0-9.]/g, '');
                            if (!checkDecimal('recoverableRatePercentage', cleaned)) {
                                changeStoreSettings(e.target.name, cleaned);
                            }
                        },
                        value: recoverableRatePercentage,
                        name: 'recoverableRatePercentage',
                        disabledDropdown: true,
                        handleOptionSelect: () => {},
                        menuOptions: [{ sign: '%', code: '%' }],
                        selectedCurrency: { sign: `%`, code: '%' },
                        autoComplete: 'off',
                    }}
                    formGroupTestId={'percentage-premium-settings-step-4-recoverable-rate'}
                />
            :
                null
            }
            <Table
                columns={columns}
                data={data}
                striped
                topHeader={topHeader}
                groups={groups}
                verticalHeader={verticalHeaders}
                outerVerticalHeader={outerVerticalHeaders}
                responsive
                tableWrapperTestId={'edit-application-premium-setting-premiums-premiums'}
            />
            {
                validationMessage
                    ? <Alert variant={ERROR} label={validationMessage} />
                    : null
            }
        </div>
    );
};

export default SharedStep4;
